import { isSandboxEnvironment } from 'BreetHelpers';
import { selectTargetEnvironment, useAppSelector } from 'BreetRedux';

export const useIsSandboxApi = () => {
	const targetEnvironment = useAppSelector(selectTargetEnvironment);

	const isSandbox = isSandboxEnvironment(targetEnvironment);

	return { isSandbox };
};
